




import { Vue, Component, Prop } from 'vue-property-decorator';
import { SelectOptions } from '@/components/Controls/Select/types';
import { setCookie } from '@/utils/cookie';
import { CatalogSortSelectProps } from './types';
import Select from '@/components/Controls/Select';

@Component({ components: { Select } })
export default class CatalogSortSelect extends Vue implements CatalogSortSelectProps {
    @Prop()
    public readonly srtOptions!: SelectOptions;

    @Prop()
    public readonly srt!: number;

    @Prop()
    public readonly metrix: any;

    public onSrtChange(value: string) {
        setCookie('srt', value,0,"","/");

        const metrix = this.$enrichVars(this.metrix || {}, {
            $property: ['srt'],
            $value: value,
        });

        this.$metrix.$emit(events.CHANGE, metrix[events.CHANGE]);
        setTimeout(() => window.location.reload(), 100);
    }
}
